@if (this.compositionTexts.length > 0) {
<div class="composition paragraph-small">
    <h-svg-icon class="icon" [name]="'composition'"></h-svg-icon>
    <h3 i18n="@@hermes.environment.category-composition" class="label">Informations environnementales</h3>
    <ul>
        @for (compositionText of this.compositionTexts; track compositionText) {
        <li>
            <!-- this level 1 section to show the value of the composition -->
            @if ( compositionText !== CONTAINS_DANGEROUS_SUBSTANCE && compositionText !==
            CONTAINS_DANGEROUS_SUBSTANCE_PACKAGING_PERFUME && compositionText !==
            CONTAINS_DANGEROUS_SUBSTANCE_PACKAGING) {

            <span [innerHtml]="compositionText"></span>

            } @else { @if (compositionText === CONTAINS_DANGEROUS_SUBSTANCE) {
            <h-agec-dangerous-substances
                [codesDangerousSubstances]="codesDangerousSubstance"
                [isPackaging]="false"></h-agec-dangerous-substances>
            } @if (compositionText === CONTAINS_DANGEROUS_SUBSTANCE_PACKAGING_PERFUME || compositionText ===
            CONTAINS_DANGEROUS_SUBSTANCE_PACKAGING) {
            <h-agec-dangerous-substances
                i18n
                [codesDangerousSubstances]="codesDangerousSubstancePackaging"
                [isPackaging]="true">
            </h-agec-dangerous-substances>
            } }
            <!-- this level 1 section is only shown if we have dangerous substance code-->
        </li>
        }
    </ul>
</div>
}
